export { default } from './MediaFilePicker.vue'
